import React from 'react';
import * as ls from "local-storage";
export default class Dashboard extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount(){
        let hash = this.props.history.location.hash;
        hash = hash.replace('#','');
        let param= this.queryStringToJSON(hash);

        if(param && param.code && param.access_token){
            ls.set("authDetails",{
                authCode:param.code,
                accessToken:param.access_token
            });
        }

        this.props.history.location.href = `/`;
        
    }

     queryStringToJSON=(qs)=> {
    
        var pairs = qs.split('&');
        var result = {};
        pairs.forEach(function(p) {
            var pair = p.split('=');
            var key = pair[0];
            var value = decodeURIComponent(pair[1] || '');
    
            if( result[key] ) {
                if( Object.prototype.toString.call( result[key] ) === '[object Array]' ) {
                    result[key].push( value );
                } else {
                    result[key] = [ result[key], value ];
                }
            } else {
                result[key] = value;
            }
        });
    
        return JSON.parse(JSON.stringify(result));
    };

    render(){

        return(

            <div>

            </div>
        )
    }
}